'use client'
import React, { createRef, LegacyRef, useState } from 'react'
import useOnClickOutside from '../../../../hooks/useOutsideClick'

export interface MainNavigationItemWrapperProps {
    children: React.ReactNode
}

export const MainNavigationItemWrapper = ({ children }: MainNavigationItemWrapperProps) => {
    const [isShowingSubItems, setIsShowingSubItems] = useState(false)
    const ref: LegacyRef<HTMLDivElement> | null = createRef()

    const handleOutsideClick = () => {
        if (isShowingSubItems) {
            setIsShowingSubItems(false)
        }
    }

    useOnClickOutside(ref, handleOutsideClick)

    return (
        <div
            ref={ref}
            className={`main-navigation__item-wrapper relative ${
                isShowingSubItems
                    ? 'main-navigation__item-wrapper--show-subitems'
                    : 'main-navigation__item-wrapper--hide-subitems'
            }`}
            onClick={() => setIsShowingSubItems(true)}
            onMouseEnter={() => setIsShowingSubItems(true)}
            onMouseLeave={() => setIsShowingSubItems(false)}
        >
            {children}
        </div>
    )
}
